import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import { Button } from 'src/components/atoms/button';
import { Typography } from 'src/components/atoms/typography';
import HeaderfulContainer from 'src/components/molecules/headerfulContainer';

export const Container = styled(HeaderfulContainer)`
  && {
    position: relative;
    margin-right: 24px;
    flex-basis: 75%;
    max-width: 75%;
    padding-bottom: 96px;
  }
`;

export const Title = styled(Typography)`
  && {
    font-size: ${props => props.theme.typography.fontSize.h2};
    color: ${props => props.theme.palette.primary.darker};
    font-weight: bold;
    text-align: center;
    margin: 24px 0 16px;
  }
`;

export const Icon = styled.div`
  && {
    width: 100%;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid ${props => props.theme.palette.grayScale[20]};
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  margin-bottom: 16px;
`;

export const StatusText = styled(Typography)`
  && {
    font-size: ${props => props.theme.typography.fontSize.medium};
    color: ${props => props.theme.palette.grayScale[80]};
    margin-left: 12px;
    text-align: center;
  }
`;

export const ErrorText = styled(Typography)`
  && {
    font-size: ${props => props.theme.typography.fontSize.medium};
    color: ${props => props.theme.palette.primary.darker};
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
  }
`;

export const WarningList = styled.ul`
  margin: 0 auto 16px;
  padding-left: 20px;
  max-width: 640px;
  color: ${props => props.theme.palette.primary.darker};
  font-size: ${props => props.theme.typography.fontSize.small};
`;

export const ReprintRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const ReprintLabel = styled(Typography)`
  && {
    font-size: ${props => props.theme.typography.fontSize.medium};
    color: ${props => props.theme.palette.grayScale[80]};
    margin: 0 8px;
  }
`;

export const RangeInput = styled(TextField)`
  && {
    width: 110px;
    margin: 0 8px;
  }
`;

export const ActionButton = styled(Button)`
  && {
    margin: 4px 8px;
  }
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  right: 24px;
  bottom: 24px;
`;
